import React from "react";

const systemMessageEvents = [
  "system-message-created",
  "system-message-deleted",
  "system-message-updated",
] as const;

export default function useSystemMessagesRefresh(userId: string | undefined, loadActiveSystemMessages: () => void) {
  const initiallyLoadedUserId = React.useRef<string | undefined>(undefined);

  React.useEffect(() => {
    if (userId && initiallyLoadedUserId.current !== userId) {
      initiallyLoadedUserId.current = userId;
      loadActiveSystemMessages();
    }

    const refresh = () => loadActiveSystemMessages();
    systemMessageEvents.forEach((eventName) => globalThis.addEventListener(eventName, refresh));

    return () => {
      systemMessageEvents.forEach((eventName) => globalThis.removeEventListener(eventName, refresh));
    };
  }, [loadActiveSystemMessages, userId]);
}
